import * as React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'
import { LiteralUnion } from '../_type/type'

const Wrapper = styled.div`
  /* 清除默认样式 */
  input {
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    background: transparent;
    appearance: none;
    -webkit-appearance: none;
    &:focus {
      outline: none;
    }
    /* global */
    flex: 1;
    /* height: inherit; */
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: 700;
    line-height: 46px;
    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
      transition: all 0.3s ease-in-out;
    }
  }
  /* chrome autocomplete background color */
  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: rgba(255, 255, 255, 1);
    transition: background-color 99999s 0s, color 99999s 0s;
  }
  /* input[data-autocompleted] {
    background-color: transparent !important;
  } */
  /* chrome autocomplete background color */
  label {
    padding: 0 12px;
    height: 46px;
    border-radius: 12px;
    background: #000000;
    border: 1px solid #000000;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
  }
  &:not(.danger, .disabled):hover label,
  label:focus-within {
    background: rgba(0, 0, 0, 0.25);
  }
  .clear {
    user-select: none;
    cursor: pointer;
    transform: scale(0.8);
    transition: all 0.3s ease-in-out;
    &:hover {
      color: #00ba3d;
      background: rgba(0, 186, 61, 0.1);
    }
  }
  /* base */
  &.danger {
    input {
      color: #ff007a;
    }
    label,
    input:focus + label {
      border: 1px solid #ff007a;
    }
  }
  &.disabled {
    filter: brightness(60%);
    opacity: 0.4;
    label,
    input {
      user-select: none;
      cursor: not-allowed;
    }
  }
`

/* eslint-disable */
type inputType = LiteralUnion<
  | 'button'
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'submit'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week',
  string
>
/* eslint-enable */

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'prefix' | 'suffix'> {
  className?: string
  type?: inputType
  danger?: boolean
  disabled?: boolean
  prefix?: React.ReactNode
  suffix?: React.ReactNode
  clear?: boolean
  onChange?: (...args: any[]) => any
  onFocus?: (...args: any[]) => any
  onBlur?: (...args: any[]) => any
  onClear?: (...args: any[]) => any
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
}

const Input: React.FC<InputProps> = React.forwardRef((props: InputProps, ref: React.Ref<HTMLInputElement>) => {
  const {
    className,
    type = 'text',
    danger = false,
    disabled = false,
    prefix,
    suffix,
    clear = false,
    value,
    onChange,
    onFocus,
    onBlur,
    onClear,
    onPressEnter,
    ...rest
  } = props

  const uuid = React.useId()

  const classes = classNames(className, {
    danger,
    disabled,
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value, e.target.name)
  }

  const handleFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFocus?.(e.target.value, e.target.name)
  }

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    onBlur?.(e.target.value, e.target.name)
  }

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return
    onPressEnter?.(e)
  }

  const handleClear = () => {
    // eslint-disable-next-line no-unused-expressions
    onClear?.() ?? onChange?.('', 'clear')
  }

  return (
    <Wrapper className={classes}>
      <label className="flex flex-row items-center justify-between" htmlFor={uuid}>
        {prefix}
        <input
          autoComplete="off"
          ref={ref}
          type={type}
          disabled={disabled}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyUp={handleEnter}
          {...rest}
        />
        {!disabled && clear && value && (
          <img
            className="clear"
            src="/newImages/launchpad/icon-close.svg"
            alt="icon"
            onClick={handleClear}
            aria-hidden
          />
        )}
        {suffix}
      </label>
    </Wrapper>
  )
})

export default Input
